import React from 'react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import { useUnit } from '../../context/UnitContext';
import { getUnitSymbol } from '../../utils/unitConversion';
import useChartTokens from '../../theme/chartTokens';
import './WaterAreaChart.css';

const ChartTooltip = ({ active, payload, label, unitSymbol, color }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="ng-chart-tooltip">
      <p className="ng-chart-tooltip__label">{label}</p>
      <p className="ng-chart-tooltip__value">
        <span className="ng-chart-tooltip__dot" style={{ background: color }} />
        Consumo: <strong>{Number(payload[0].value).toFixed(2)} {unitSymbol}</strong>
      </p>
    </div>
  );
};

export default function WaterAreaChart({
  data = [],
  title = "Flujo promedio últimas 5 horas",
  subtitle,
  height = 280,
  rightSlot,
}) {
  const { selectedUnit, convertValue } = useUnit();
  const unitSymbol = getUnitSymbol(selectedUnit);
  const chart = useChartTokens();

  const convertedData = data.map((item) => ({
    ...item,
    consumption: convertValue(item.consumption),
  }));

  return (
    <div className="ng-area-chart">
      <div className="ng-area-chart__head">
        <div>
          <h3 className="ng-area-chart__title">{title}</h3>
          {subtitle && <p className="ng-area-chart__subtitle">{subtitle}</p>}
        </div>
        {rightSlot}
      </div>

      <ResponsiveContainer width="100%" height={height}>
        <AreaChart data={convertedData} margin={{ top: 10, right: 16, left: 0, bottom: 0 }}>
          {/* Un solo color con desvanecido. El degradado aquí describe densidad
              de dato, no decora la interfaz. */}
          <defs>
            <linearGradient id="ngAreaFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={chart.water} stopOpacity={0.22} />
              <stop offset="100%" stopColor={chart.water} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke={chart.grid} vertical={false} />
          <XAxis
            dataKey="hour"
            tickLine={false}
            axisLine={false}
            tick={{ fill: chart.axis, fontSize: 12 }}
          />
          <YAxis
            tickLine={false}
            axisLine={false}
            tick={{ fill: chart.axis, fontSize: 12 }}
            width={40}
          />
          <Tooltip
            content={<ChartTooltip unitSymbol={unitSymbol} color={chart.water} />}
            cursor={{ stroke: chart.border, strokeWidth: 1 }}
          />
          <Area
            type="monotone"
            dataKey="consumption"
            stroke={chart.water}
            strokeWidth={2}
            fill="url(#ngAreaFill)"
            activeDot={{ r: 4, stroke: chart.water, strokeWidth: 2, fill: chart.surface }}
            dot={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
